export default "__VITE_ASSET__It0BVj_9__"